// extracted by mini-css-extract-plugin
export default {"soundContainer":"visualiser_soundContainer__T-qjS"};